import {RefObject, createContext} from "react";

import type {ThreeEvent} from "@react-three/fiber";
import type {GameObjectType, ShapeType, TLevelObject} from "@repo/shared";
import type * as THREE from "three";

export interface SelectionContextType {
  addAndSelect: (objects: TLevelObject[]) => void;
  dragging: RefObject<boolean>;
  multiSelection: RefObject<boolean>;
  clearSelection: () => void;
  deleteSelected: () => void;
  applyTransformToSelected: (
    matrices: THREE.Matrix4 | THREE.Matrix4[],
    skipBoundingBox?: boolean,
  ) => void;
  selectInstance: (instanceId: number, shapeType: ShapeType) => void;
  handleSelectClick: (
    event: ThreeEvent<MouseEvent>,
    shapeType: ShapeType,
  ) => void;
  handleUnselectClick: (
    event: ThreeEvent<MouseEvent>,
    shapeType: ShapeType,
  ) => void;
  recalculateBoundingBox: () => void;
  selectArea: (boundingBox: {
    minX: number;
    maxX: number;
    minY: number;
    maxY: number;
  }) => void;
  selectionBoundingBox: RefObject<THREE.Object3D | null>;
  selectedObject: RefObject<THREE.Object3D | null>;
  currentGameObjectType: RefObject<GameObjectType>;
}

export const SelectionContext = createContext<SelectionContextType | undefined>(
  undefined,
);
